import { ReactNode, useCallback, useState } from 'react'
import { PageType, WithdrawalPageTypeContext } from './context'

export function PageTypeProvider({ children }: { children: ReactNode }): JSX.Element {
  const [pageType, setPageType] = useState<PageType>('begin')

  const updatePageType = useCallback((nextPageType: PageType) => {
    setPageType(nextPageType)
  }, [])

  // 『戻る』ボタンを表示するのは解約選択画面と解約確認画面のみ
  const isVisiblePageBack = pageType === 'select_reason' || pageType === 'confirm'

  return (
    <WithdrawalPageTypeContext.Provider value={{ pageType, updatePageType, isVisiblePageBack }}>
      {children}
    </WithdrawalPageTypeContext.Provider>
  )
}
